import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import linkedinImg from "../images/linkedin.svg"
import uploadFolderImg from "../images/upload-folder.svg"
import arrowForwardImg from "../images/arrow-forward.svg"
import $ from 'jquery';
import { storage } from "../firebase";
import { guidance, database } from '../firebase'
import moment from 'moment';
export default class AssesmentApply1 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fileName: false,
      resumeImage:null,
      progress: 0,
      url:null,
      resumeLink:"",
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
  }
  handleChange = (event) => {
    const { value, name } = event.target;
    this.setState({
        [name]: value,
    });
};
   componentDidMount() {
    //localStorage.setItem("guidanceId", this.props.match.params.key);
    //alert(this.props.match.params.key)
  }
  handleImageChange = e => {
    if (e.target.files[0]) {
        this.setState({
          resumeImage: e.target.files[0],
            fileName: true
            
        })
    }
};
  updateValidateSubmission = () => {        
         if (this.state.fileName===true) {        
            const uploadTask = storage.ref(`Guidance/${this.state.resumeImage.name}`).put(this.state.resumeImage);
            uploadTask.on(
                "state_changed",
                snapshot => {
                    const progress = Math.round(
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    );
                    this.setState({
                        progress: progress
                    })
                },
                error => {
                    console.log(error);
                },
                () => {
                    storage
                        .ref("Guidance")
                        .child(this.state.resumeImage.name)
                        .getDownloadURL()
                        .then(url => {
                            console.log("url...",url)
                            $("#imageUrl")
                            .attr('src', url);
                            this.setState({
                                url: url
                            });
                            this.updateData()                                                      
                        });
                      }
            );
           
         }
         else{
          
           this.updateData()
         }
       
}
  updateData (){
   
    let newDate = moment(new Date()).format("DD/MM/YYYY")
    const dataSet = {     
      resumeFile:this.state.url===null ? "" : this.state.url,
      resumeLink:this.state.resumeLink,
      step2:"true",
      progressInfo:20
       
  }
    database.ref(`Guidance/${this.props.match.params.key}`).update(dataSet).then(() => {
        window.location.href = "/assesment/apply-2/id="+this.props.match.params.key       

    }).catch(() => {
        alert("Somthing went wrong")
    })
}
    render() {

    return (

      <div className="main-wrapper assesment-wrapper">
        <Header></Header>
        <div className="main-content p-0" style={{background: "#f4f6f9" }}>    
            <div className="container p-0 pt-5">
              <div className='row'>
                <div className='col-lg-6 m-auto p-0'>
                  <form className='form-main-wrapper'>
                    <div className='form-group progress-det'>
                      <span className='progress-content'>Step 2/5</span>
                      <div className="progress">
                        <div className="progress-bar" role="progressbar" style={{width:"40%"}} aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                    <hr></hr>
                    <div className='form-group subhead text-left'>Share your profile</div>
                    <div className="form-group">                        
                      <p>To move forward with our course recommendation process, we ask that you share either your resume or a LinkedIn profile.  <span className='text-danger'>*</span></p>
                    </div>
                    <div className="form-group">
                      <label for="resumeImage" className="form-fileUpload">
                        <input name="resumeImage" id="resumeImage" type="file" onChange={this.handleImageChange} accept=".pdf,.doc,.docx" />
                        <div className="FormFileUpload_uploadContent__1quqH">
                          <img alt="Resume Upload" src={uploadFolderImg} />
                          <span className="form-fileUpload-title">Resume Upload</span>
                          <span className="form-fileUpload-helpText">.pdf, .doc, or .docx</span>
                        </div>
                      </label>
                    </div>
                    <div className="form-group text-center">
                      <label>OR</label>
                    </div>
                    <div className="form-group">
                      <div className="input-group">
                          <span className="input-group-text">
                            <img src={linkedinImg}></img>
                          </span>
                          <input type="text" onChange={this.handleChange} className="form-control" name="resumeLink" id="resumeLink" placeholder="https://linkedin.com/in/profile" />
                      </div>
                    </div>
                    <div className="form-group mt-4">
                      <a className="btn btn-gray w-100" onClick={()=>this.updateValidateSubmission()}>
                        Next <img src={arrowForwardImg} className="arrow-filter"></img>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            
        </div>
        
      </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/ivano/assesment-apply1.jsx